<template>
  <div class="pre">
    <div class="pre__panel">
      <div class="panel">
        <div class="panel__header">
          <p>事前学習</p>
        </div>
        <div class="panel__body">
          <div class="panel__content">

            <div v-if="studyId == 1" class="page-box">
              <div class="pages">
                <transition>
                  <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings" tagname="div" ref="psb">
                    <div v-if="currentPage == 1" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_1_1.png`">
                    </div>
                    <div v-else-if="currentPage == 2" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_1_2.png`">
                    </div>
                    <div v-else-if="currentPage == 3" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_1_3.png`">
                    </div>
                    <div v-else-if="currentPage == 4" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_1_4.png`">
                    </div>
                  </VuePerfectScrollbar>
                </transition>
              </div>
              <div class="page-nav">
                <ul class="nav">
                  <li class="nav-item" :class="{isReaded:currentPage >= 1}">
                    <span @click="changePage(1)">1</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 2}">
                    <span @click="changePage(2)">2</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 3}">
                    <span @click="changePage(3)">3</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 4}">
                    <span @click="changePage(4)">4</span>
                  </li>
                </ul>
              </div>
            </div>

            <div v-else-if="studyId == 2" class="page-box">
              <div class="pages">
                <transition>
                  <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings" tagname="div" ref="psb">
                    <div v-if="currentPage == 1" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_2_1.png`">
                    </div>
                    <div v-else-if="currentPage == 2" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_2_2.png`">
                    </div>
                    <div v-else-if="currentPage == 3" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_2_3.png`">
                    </div>
                    <div v-else-if="currentPage == 4" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_2_4.png`">
                    </div>
                    <div v-else-if="currentPage == 5" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_2_5.png`">
                    </div>
                    <div v-else-if="currentPage == 6" class="page">
                      <img :src="`${staticPath}img/factory/study/pre/page_2_6.png`">
                    </div>
                  </VuePerfectScrollbar>
                </transition>
              </div>
              <div class="page-nav">
                <ul class="nav">
                  <li class="nav-item" :class="{isReaded:currentPage >= 1}">
                    <span @click="changePage(1)">1</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 2}">
                    <span @click="changePage(2)">2</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 3}">
                    <span @click="changePage(3)">3</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 4}">
                    <span @click="changePage(4)">4</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 5}">
                    <span @click="changePage(5)">5</span>
                  </li>
                  <li class="nav-item" :class="{isReaded:currentPage >= 6}">
                    <span @click="changePage(6)">6</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <div class="panel__footer">
          <div v-if="isGoTest" v-on:click="gotoTest" class="btn-start">
            <img :src="`${staticPath}img/factory/study/pre/btn_start_ok.png`">
          </div>
          <div v-else class="btn-start">
            <img :src="`${staticPath}img/factory/study/pre/btn_start.png`">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/study_pre.scss';

  .scroll-area {
    height: 100%;
    padding-right: 15px;
  }
</style>

<style lang="scss">
  @import '@/assets/scss/_scrollbar.scss';
</style>

<script>
  import Constant from '@/constant';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: 'PreStudy',
    props: ['studyId'],

    components: {
      VuePerfectScrollbar
    },

    data(){
      return {
        staticPath: Constant.STATICPATH,
        currentPage: 1,
        pageMax: 1,
        isGoTest: false,

        settings: {
          suppressScrollX: true,
          swipeEasing: false
        },
      }
    },

    created() {
      if (this.studyId == 1) {
        this.pageMax = 4;
      } else if (this.studyId == 2) {
        this.pageMax = 6;
      }
    },

    methods: {

      changePage(page_id) {

        // スクロールバーを元の位置に戻す
        const psb = this.$refs.psb;

        if (psb && psb.$el) {
          psb.$el.scrollTop = 0;
          psb.update();
        }

        // 前のページか次のページのみ
        if ((page_id <= this.currentPage) || (page_id == this.currentPage + 1)) {
          this.currentPage = page_id;
        }

        // 最後の設問
        if (this.currentPage >= this.pageMax) {
          this.isGoTest = true;
        }
      },

      gotoTest() {

        if (this.isGoTest) {
          this.$emit('goto-test-study', this.studyId);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/PreStudy.vue